import transcosmosLogoType from './assets/logo_transcosmos.svg'

import './Onboarding.scss'

const TranscosmosLogotype = (): JSX.Element => (
  <img
    className="transcosmos-logotype"
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    src={transcosmosLogoType}
    alt="Transcosmos logo"
  />
)

export default TranscosmosLogotype
